export const ExtensionsRegistryId = 0;
